import { ProfilePage } from "@/screens/profile-screens/profile";

export default function ProfileIndex() {
  return <ProfilePage />;
}
